import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  isWorkspaceScopedApiPath,
  resolveStoredWorkspaceId,
} from '../utils/workspace.util';

@Injectable()
export class WorkspaceInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    if (!req.url.includes('/api/') || !isWorkspaceScopedApiPath(req.url)) {
      return next.handle(req);
    }

    if (req.params.has('workspaceId')) {
      return next.handle(req);
    }

    const workspaceId = resolveStoredWorkspaceId();
    if (!workspaceId) {
      return next.handle(req);
    }

    return next.handle(
      req.clone({
        params: req.params.set('workspaceId', workspaceId),
      }),
    );
  }
}
